import type {ScheduleInterval} from './types';

import {DAY_SLOTS_COUNT, SCHEDULE_SLOT_DURATION} from './constants';

export const updateSchedule = (
  bits: string,
  dayIndex: number,
  interval: ScheduleInterval, // array of minutes from midnight
  value: number = 0,
): string => {
  let [startPosition, endPosition] = interval;

  if (interval.some(minutes => minutes % SCHEDULE_SLOT_DURATION !== 0)) {
    return bits;
  }

  /**
   * If the endPosition points to the end of the day (12:00 AM for example)
   * set to end of the day
   */
  if (startPosition > endPosition && endPosition === 0) {
    endPosition = 24 * 60;
  }

  const startIndex =
    dayIndex * DAY_SLOTS_COUNT + startPosition / SCHEDULE_SLOT_DURATION;

  if (startIndex >= bits.length) {
    return bits;
  }

  const changesCount = (endPosition - startPosition) / SCHEDULE_SLOT_DURATION;

  const result = bits.split('');

  result.splice(
    startIndex,
    changesCount,
    ...new Array(changesCount).fill(`${value}`),
  );

  return result.join('');
};
